import React from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useBonusRevenueRules, useCompanies, useTeams } from '../../../hooks';
import { SCREENS } from '../../../constants/permissions';
import AddIcon from '@mui/icons-material/Add';

// Form select'lerini hooks'tan doldur. customFormFields verince DynamicCrudPage'in
// default companyId auto-fill'i çalışmadığı için companyId'yi de burada
// dolduruyoruz (workStatus pattern'i tutsun diye).
const buildFormFields = (fields, additionalData, isRootUser) => {
  const teamList = additionalData?.teams?.teams || [];
  const companyList = additionalData?.companies?.companies || [];

  return fields
    .map((f) => {
      if (f.name === 'companyId') {
        return {
          ...f,
          options: companyList.map((c) => ({ value: c.id, label: c.name })),
          showIf: () => isRootUser,
        };
      }
      if (f.name === 'team_ids') {
        return {
          ...f,
          // Boş array = şirket geneli (junction'da hiç kayıt olmaz).
          options: teamList.map((t) => ({ value: t.id, label: t.name })),
        };
      }
      return f;
    })
    .filter((f) => (f.name === 'companyId' ? isRootUser : true));
};

const PrimCiroKurallariPage = () => (
  <DynamicCrudPage
    entityType="bonusRevenueRules"
    screen={SCREENS.PRIM_MANAGEMENT}
    hook={useBonusRevenueRules}
    additionalHooks={{ companies: useCompanies, teams: useTeams }}
    addButtonTextKey="bonusRevenueRules.actions.add"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="bonusRevenueRules"
    customFormFields={buildFormFields}
  />
);

export default PrimCiroKurallariPage;
